import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const beforeAfter = [['Hours planning every week', 'Classes ready in minutes'], ['Doubt about what to teach', 'Clarity and direction every session'], ['Repeated combinations', 'Fresh, dynamic content every class'], ['Students who slowly stop showing up', 'Students who bring their friends'], ['Mental exhaustion before class', 'Full energy for what matters: your class']];
export function SolutionReveal() {
  const notThis = ['Not a random collection of routines and movement ideas.', 'Not a theory resource you have to translate into a real class.', 'Not a system designed for only one level, style, or teaching environment.'];
  return <section className="border-y border-line bg-white px-4 py-20" data-id="element-201">
      <div className="mx-auto max-w-4xl text-center" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-203">
          <p className="mb-4 text-3xl text-orange" aria-hidden="true" data-id="element-204">
            ✦
          </p>
          <h2 className="font-display text-3xl font-bold text-navy sm:text-4xl" data-id="element-205">
            The solution you have been looking for: a complete 7-in-1 system
          </h2>
          <p className="mt-4 text-lg font-bold text-orange" data-id="element-206">
            Dance Fitness Instructor Pro™
          </p>
          <p className="mt-3 text-sm text-slate-600" data-id="element-207">
            7 professional modules · 5 premium bonuses · Ready to teach from
            minute one
          </p>
        </motion.div>

        <div className="mt-10 grid gap-5 text-left md:grid-cols-2" data-id="element-208">
          <div className="space-y-4 rounded-2xl border border-red-100 bg-[#FFF7F5] p-6" data-id="element-209">
            {notThis.map(item => <p key={item} className="flex gap-3 text-sm leading-relaxed text-slate-600" data-id="element-210">
                <XIcon size={18} className="shrink-0 text-red-400" data-id="element-211" />
                {item}
              </p>)}
          </div>
          <div className="rounded-2xl border border-navy/20 bg-soft p-6" data-id="element-212">
            <p className="flex gap-3 text-base font-medium leading-relaxed text-navy" data-id="element-213">
              <CheckIcon size={20} className="mt-0.5 shrink-0 text-orange" data-id="element-214" />A
              complete professional operating system to help you deliver
              dynamic, structured, effective dance fitness classes for every
              level, style, age group, and teaching environment.
            </p>
            <p className="mt-5 text-sm font-semibold text-navy" data-id="element-215">
              Open the system. Choose your structure. Teach with confidence.
            </p>
          </div>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-line bg-white text-left" data-id="element-216">
          <div className="grid grid-cols-2 border-b border-line text-xs font-bold uppercase tracking-wider" data-id="element-217">
            <p className="bg-soft p-4 text-slate-500" data-id="element-218">Before</p>
            <p className="border-l border-line bg-navy p-4 text-white" data-id="element-219">After</p>
          </div>
          {beforeAfter.map(([before, after]) => <div key={before} className="grid grid-cols-2 border-b border-line last:border-0" data-id="element-220">
              <p className="bg-slate-50 p-4 text-sm text-slate-500" data-id="element-221">{before}</p>
              <p className="border-l border-line p-4 text-sm font-medium text-navy" data-id="element-222">
                {after}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}